import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class GithubSyncClientService {
  constructor(private http: HttpClient) {}

  public syncDatasetToGithub(token: string, org: string, commitMessage: string): Observable<any> {
    return this.http
      .patch<any>(`/api/${org}/datasets/${token}/sync_to_github`, { commit_message: commitMessage })
      .pipe(map((response) => response));
  }

  public syncDefinitionToGithub(token: string, org: string, commitMessage: string): Observable<any> {
    return this.http
      .patch<any>(`/api/${org}/definitions/${token}/sync_to_github`, { commit_message: commitMessage })
      .pipe(map((response) => response));
  }

  public syncReportToGithub(token: string, org: string, commitMessage: string): Observable<any> {
    return this.http
      .patch<any>(`/api/${org}/reports/${token}/sync_to_github`, { commit_message: commitMessage })
      .pipe(map((response) => response));
  }
}
